/**
 * Vardiya deseni yardımcıları (İK Faz 2, 03.11.2026). Desen gün gün vardiya kodlarıdır, "HT" hafta tatili; doğrulamanın
 * asıl sahibi sunucudur (VardiyaHesap.DesenHatasi), burada yalnız önizleme ve hızlı uyarı yapılır.
 */

export const TATIL_KODU = 'HT';
export const DESEN_EN_FAZLA = 62;

export const desenKodlari = (desen: string | undefined | null): string[] =>
    (desen ?? '').split(/[,; ]+/).map(x => x.trim().toLocaleUpperCase('tr-TR')).filter(x => x != '');

/** Sunucunun reddedeceği deseni kayıttan önce yakalar; sorun yoksa null. */
export const desenHatasi = (desen: string | undefined | null, tanimliKodlar: string[]): string | null => {
    const kodlar = desenKodlari(desen);
    if (kodlar.length == 0)
        return 'Deseni giriniz (ör. S,S,S,S,S,HT,HT).';
    if (kodlar.length > DESEN_EN_FAZLA)
        return `Desen en çok ${DESEN_EN_FAZLA} gün olabilir.`;
    const tanimli = new Set(tanimliKodlar.map(x => x.toLocaleUpperCase('tr-TR')));
    const bilinmeyen = Array.from(new Set(kodlar.filter(x => x != TATIL_KODU && !tanimli.has(x))));
    return bilinmeyen.length > 0 ? `Tanımsız vardiya kodu: ${bilinmeyen.join(', ')}.` : null;
}

/** "HH:mm" -> dakika. */
export const dakika = (hhmm: string) => Number(hhmm.substring(0, 2)) * 60 + Number(hhmm.substring(3, 5));

/**
 * Ara ve molalar düşülmüş süre (dk); gece yarısını geçen vardiyada bitiş ve gece yarısından sonraki ara / mola ertesi gün sayılır
 * (sunucudaki CalismaDk ile aynı). molalar: "HH:mm-HH:mm"; çakışan aralıklar bir kez düşülür.
 */
export const calismaDk = (bas: string, bit: string, araBas?: string | null, araBit?: string | null, molalar: string[] = []): number => {
    const b = dakika(bas);
    let s = dakika(bit);
    const gece = s <= b;
    if (gece) s += 1440;
    const araliklar: [number, number][] = [];
    const ekle = (x0: string, y0: string) => {
        let x = dakika(x0), y = dakika(y0);
        if (gece && x < b) { x += 1440; y += 1440; }
        if (gece && y <= x) y += 1440;
        const k0 = Math.max(x, b), k1 = Math.min(y, s);
        if (k1 > k0) araliklar.push([k0, k1]);
    };
    if (araBas && araBit) ekle(araBas, araBit);
    molalar.map(m => m.split(/\s*[-–]\s*/)).filter(p => p.length == 2 && /^\d\d:\d\d$/.test(p[0]) && /^\d\d:\d\d$/.test(p[1])).forEach(p => ekle(p[0], p[1]));
    araliklar.sort((p, q) => p[0] - q[0]);
    let dusen = 0, cb = -1, cs = -1;
    for (const [x, y] of araliklar) {
        if (cs >= 0 && x <= cs) { cs = Math.max(cs, y); continue; }
        if (cs >= 0) dusen += cs - cb;
        cb = x; cs = y;
    }
    if (cs >= 0) dusen += cs - cb;
    return s - b - dusen;
}

export const saatMetni = (dk: number) => dk % 60 == 0 ? `${Math.floor(dk / 60)} sa` : `${Math.floor(dk / 60)} sa ${dk % 60} dk`;

/** Vardiya kodlarına sabit sıra ile renk; HT gri, izin yeşil (puantajla aynı). */
const PALET = ['#E3F2FD', '#FFF3E0', '#EDE7F6', '#FCE4EC', '#E0F7FA', '#FFFDE7', '#F3E5F5', '#E8EAF6'];
const YAZI = ['#0D47A1', '#E65100', '#4527A0', '#AD1457', '#006064', '#827717', '#6A1B9A', '#283593'];

export const vardiyaRengi = (kod: string | null | undefined, kodlar: string[]): { background: string, color: string } => {
    if (!kod)
        return { background: 'transparent', color: '#A1A5B7' };
    if (kod == TATIL_KODU)
        return { background: '#F1F1F4', color: '#78829D' };
    const i = kodlar.indexOf(kod);
    const n = i < 0 ? 0 : i % PALET.length;
    return { background: PALET[n], color: YAZI[n] };
}

export const IZIN_RENGI = { background: '#DFF5EA', color: '#1B7F4C' };
